var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSettingsWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27.2,
  height: 27
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Settings_white_svg__clip-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h27.2v27H0z",
  className: "Settings_white_svg__cls-1"
})), /*#__PURE__*/React.createElement("style", null, ".Settings_white_svg__cls-1{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Settings_white_svg__Settings",
  clipPath: "url(#Settings_white_svg__clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Settings_white_svg__\\uC0AC\\uAC01\\uD615_193",
  d: "M0 0h27v27H0z",
  className: "Settings_white_svg__cls-1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Settings_white_svg__\\uD328\\uC2A4_104",
  fill: "#fff",
  fillRule: "evenodd",
  d: "M272.928 16.875a3.376 3.376 0 1 0-3.448-3.375 3.42 3.42 0 0 0 3.448 3.375m-7.067-10.8A9.8 9.8 0 0 1 270 3.881L271.376 0h3.447l1.377 3.881a12.1 12.1 0 0 1 4.137 2.194l4.137-.844 1.726 3.038-2.758 3.037a9.4 9.4 0 0 1 .172 2.194c0 .675-.172 1.519-.172 2.194l2.758 3.037-1.724 3.037-4.137-.844a9.8 9.8 0 0 1-4.137 2.194L274.824 27h-3.447L270 23.119a12.1 12.1 0 0 1-4.137-2.194l-4.137.844L260 18.731l2.758-3.037a9.4 9.4 0 0 1-.172-2.194c0-.675.172-1.519.172-2.194L260 8.269l1.724-3.037z",
  transform: "translate(-259)"
}))));
export { SvgSettingsWhite as ReactComponent };
export default __webpack_public_path__ + "static/media/Settings_white.ba4dcf64.svg";